import { DatePickerTabs } from './DatePickerTabs';

export default DatePickerTabs;
